import {useCallback, useEffect} from 'react';

import {ChannelViewLayout} from 'shells/inbox/messages/channel-view-layout';
import {ChatSidebarHeader} from 'shells/inbox/sidebar/chat-sidebar-header';
import {Sidebar} from 'shells/sidebar/sidebar';
import {UserSelectButton} from 'shells/user-select-button/user-select-button';

import {ThreadStatus} from 'nutshell-graphql-types';

import {appHistory} from '../../../history';

import {useGetUsers} from '../../core/select/hooks';
import {OpenableModals, useOpenableModal} from '../../openable-modals';

import {useGetChannelEvents, useGetInboxThreadById} from '../graphql/hooks';

type Props = {
    entityId: string;
    openedFromEntityName: string;
    channelId: string | null | undefined;
    threadId: string | null | undefined;
};

export function ThreadSidebarWrapper(props: Props) {
    const {onClose} = useOpenableModal(OpenableModals.THREAD_SIDEBAR);
    const {thread: selectedThread, isLoading: isLoadingThread} = useGetInboxThreadById(
        props.threadId
    );
    const {users} = useGetUsers();
    const {
        channelEvents,
        isLoading: isLoadingChannelEvents,
        fetchMostRecentChannelEvents,
        refetchScheduledChannelEvents,
        hasNextPage,
        fetchMoreRows,
        sendabilityStatus,
    } = useGetChannelEvents(props.channelId, props.threadId);

    const handleClose = useCallback(() => {
        Timeline.refreshTimeline();
        onClose();
    }, [onClose]);

    // Close modal when route changes
    useEffect(() => {
        const unlisten = appHistory.listen(() => {
            handleClose();
        });

        return unlisten;
    }, [handleClose]);

    const selectedThreadStatus = selectedThread && selectedThread.effectiveStatus;
    const selectedThreadOwnerId = selectedThread && selectedThread.owner && selectedThread.owner.id;

    return (
        <Sidebar
            isOpen={true}
            preventBodyScroll={true}
            canClickOutsideToClose={true}
            canEscapeToClose={true}
            onClose={handleClose}
        >
            <ChatSidebarHeader
                isLoading={isLoadingThread}
                // @ts-expect-error
                recipient={
                    selectedThread && {
                        ...selectedThread.bestEntity,
                        phoneNumber: '',
                    }
                }
                status={selectedThreadStatus}
                assigneeButton={
                    <UserSelectButton
                        isSmall={true}
                        isReadOnly={true}
                        selectedUserId={selectedThreadOwnerId}
                        users={users}
                        onSelect={() => {}}
                    />
                }
                openedFromEntityId={props.entityId}
                // @ts-expect-error
                onUpdateStatus={null}
            />
            <ChannelViewLayout
                isLoadingChannelEvents={isLoadingChannelEvents}
                isLoadingTextables={isLoadingThread}
                channelEvents={channelEvents}
                fetchMoreRows={fetchMoreRows}
                hasNextPage={hasNextPage}
                onCloseSidebar={onClose}
                fetchMostRecentChannelEvents={fetchMostRecentChannelEvents}
                refetchScheduledChannelEvents={refetchScheduledChannelEvents}
                openedFromEntityName={props.openedFromEntityName}
                cantSendStatus={sendabilityStatus}
                shouldHideMessageInput={selectedThreadStatus === ThreadStatus.CLOSED}
                threadId={props.threadId || undefined}
                threadType={selectedThread?.threadType}
                sessionId={selectedThread?.externalChannel?.sessionId || ''}
                // @ts-expect-error
                recipient={
                    selectedThread && {
                        ...selectedThread.bestEntity,
                        phoneNumber: '',
                    }
                }
                isSidebar={true}
            />
        </Sidebar>
    );
}
